<div class="quick-action-bubble fixed left-3 bottom-4 z-99">
    <button mat-raised-button color="primary" matTooltip="Quick init new app" (click)="initNewApp()">
        <mat-icon>add</mat-icon>
        {{ 'CONTROL.LABEL.QUICK_INIT_APP' | transloco}}
    </button>
</div>